// Ustawienie: w jakim języku bot mówi uwagi w lekcji (angielski albo polski). Zapisane tylko w tej przeglądarce; bez zapisu — wartość z konfiguracji.
import { config } from '../config.ts';
import type { TeacherLang } from '../types.ts';
import type { StorageLike } from './attemptLog.ts';

export const TEACHER_KEY = 'naative.teacher.v1';

export interface TeacherSettings {
  lang(): TeacherLang;
  set(lang: TeacherLang): void;
  /** Wywołuje `fn` po każdej zmianie języka (nie po ustawieniu tej samej wartości); zwraca funkcję wyłączającą nasłuch. */
  onChange(fn: (lang: TeacherLang) => void): () => void;
}

export function createTeacherSettings(store: Pick<StorageLike, 'getItem' | 'setItem'> | null, fallback: TeacherLang = config.teacher.defaultLang): TeacherSettings {
  const listeners = new Set<(lang: TeacherLang) => void>();
  let session: TeacherLang | null = null; // gdy pamięć przeglądarki nie działa, wybór i tak obowiązuje do końca tej sesji
  const api: TeacherSettings = {
    lang() {
      try {
        const raw = store?.getItem(TEACHER_KEY);
        if (raw) {
          const v = (JSON.parse(raw) as { lang?: unknown }).lang;
          if (v === 'en' || v === 'pl') return v;
        }
      } catch {
        /* uszkodzony zapis albo brak dostępu do pamięci — wartość domyślna */
      }
      return session ?? fallback;
    },
    set(lang) {
      const before = api.lang();
      session = lang;
      try {
        store?.setItem(TEACHER_KEY, JSON.stringify({ lang }));
      } catch {
        /* bez pamięci ustawienie nie przetrwa odświeżenia — nic się nie psuje */
      }
      if (lang !== before) for (const fn of [...listeners]) fn(lang);
    },
    onChange(fn) {
      listeners.add(fn);
      return () => void listeners.delete(fn);
    },
  };
  return api;
}
